/**
 * @fileoverview Workspace Task Statuses
 *
 * URL: /dashboard/task-statuses
 *
 * Firm-defined workflow statuses (kanban columns + task workflow state).
 * Lives under the workspace Calendar section in the sidebar (more logical
 * than buried in Settings). Admin/owner can create, edit, recolour, re-type
 * and reorder; system statuses are protected from deletion.
 *
 * - Convex: tasks.statuses.*
 */
import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@cvx/_generated/dataModel";
import { useActiveOrg } from "@/utils/org-context";
import { TaskStatusesManager } from "@/components/settings/tasks/TaskStatusesManager";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/task-statuses",
)({
  component: TaskStatusesPage,
});

function TaskStatusesPage() {
  const { orgId, activeOrg } = useActiveOrg();
  const canEdit = activeOrg?.role === "owner" || activeOrg?.role === "admin";

  return (
    <div className="flex flex-1 flex-col gap-5 bg-muted p-6">
      {orgId ? (
        <TaskStatusesManager
          orgId={orgId as Id<"organizations">}
          canEdit={canEdit}
        />
      ) : (
        <div className="text-sm text-muted-foreground">
          Select an organisation to manage task statuses.
        </div>
      )}
    </div>
  );
}
